'use strict';

var React = require('react');

var SvgBlockquoteMajor = function SvgBlockquoteMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 3.5a1 1 0 0 0-1 1v.5h.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-3a3 3 0 0 1 3-3v2zm5.5 1.5h-.5v-.5a1 1 0 0 1 1-1v-2a3 3 0 0 0-3 3v3a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5zm3.5 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1zm-8 3a1 1 0 1 0 0 2h15a1 1 0 1 0 0-2h-15zm-1 5a1 1 0 0 1 1-1h15a1 1 0 1 1 0 2h-15a1 1 0 0 1-1-1zm10-13a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6z"
  }));
};

exports.SvgBlockquoteMajor = SvgBlockquoteMajor;
